import { useStore, useStoreUI } from '@assets/model/Store';
import { observer } from 'mobx-react';
import { Flex } from '../UI/Flex/Flex';

import * as style from './ModalPickFile.module.less';
import { Button } from 'react-bootstrap';
import { useState } from 'react';
import { cleanFilenameForDisplay } from '@assets/utils/Utils';
import { sanitizeName } from '@assets/firebase/FirebaseAdapater';
import { ScrollPanel } from '../Panel/ScrollPanel/ScrollPanel';
import Checkbox from '../UI/Checkbox/Checkbox';

interface ModalPickFileProps {
    onSelectFile: (fileStoragePath: string[]) => void;
}

export const ModalPickFile = observer((props: ModalPickFileProps) => {
    const store = useStore();
    const [pickedFiles, setPickedFiles] = useState<{
        [filename: string]: boolean;
    }>({});

    const onSubmitSelection = () => {
        const selectedFiles = Object.keys(pickedFiles).filter(
            filename => pickedFiles[filename]
        );
        const withPath = selectedFiles.map(fn => {
            try {
                if (
                    store.query.value('pdf').toLowerCase() === fn.toLowerCase()
                ) {
                    return 'pdfs/' + fn;
                }
            } catch (error) {
                console.error('Error comparing PDF filenames:', error);
            }

            return `rag/${store.selectedReportId}/${fn}`;
        });

        props.onSelectFile(withPath);
    };

    const filesList = store.projectFiles;
    var filesEl = [];
    const onSelectFile = (fileId: string) => {
        console.log('Selected file:', fileId);
        const companyId = store.selectedReportId;

        const pickedFilesCopy = { ...pickedFiles };
        if (pickedFilesCopy[fileId]) {
            pickedFilesCopy[fileId] = !pickedFilesCopy[fileId];
        } else {
            pickedFilesCopy[fileId] = true;
        }
        setPickedFiles(pickedFilesCopy);

        //props.onSelectFile([`rag/${companyId}/${fileId}`]);
    };

    for (var fileId in filesList.files) {
        const file = filesList.files[fileId];
        const isPicked = pickedFiles[file.filename];
        filesEl.push(
            <div
                className={style.fileEntry}
                key={fileId}
                style={{
                    backgroundColor: isPicked ? '#c4d3eb' : 'transparent'
                }}
                onClick={() => {
                    onSelectFile(file.filename);
                }}
            >
                <Flex direction="row">
                    <div style={{ alignSelf: 'center', marginRight: '15px' }}>
                        <Checkbox checked={isPicked} onChange={() => {}} />
                    </div>
                    <Flex direction="column">
                        <div>{cleanFilenameForDisplay(file.filename)}</div>
                        <div className="flex-grow" />
                        <div className={style.fileSummary}>
                            {file.summary?.doc_overview ??
                                'No summary available'}
                        </div>
                    </Flex>
                </Flex>
            </div>
        );
    }
    filesEl.push(
        <div key="padding" style={{ height: '10px', width: '100%' }}></div>
    );
    return (
        <>
            <Flex fillCell={true} direction="column" alignItems="center">
                <ScrollPanel>
                    <Flex
                        direction="column"
                        style={{
                            width: '100%',
                            gap: '12px'
                        }}
                    >
                        {filesEl}
                    </Flex>
                </ScrollPanel>
                <div className={style.seperator}></div>
                <Flex direction="row" style={{ width: '100%', height: '40px' }}>
                    <Button
                        onClick={() => {
                            const ui = useStoreUI();
                            ui.modal = null;
                        }}
                        className={style.cancelButton}
                    >
                        Cancel
                    </Button>
                    <div style={{ flexGrow: 1 }}></div>
                    <Button
                        onClick={onSubmitSelection}
                        className={style.confirmButton}
                    >
                        Confirm
                    </Button>
                </Flex>
            </Flex>
        </>
    );
});
